import { Registry } from '@react-registry'

export const OL = () => {
    return {
        type: 'ol',
    }
}

Registry.register(OL, { id: 'OL', registry: 'v2.deserializer' })